var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Falcon } from 'modules/macro';
import { useGeneratedId } from 'modules/utils';
import { Loader } from 'modules/v2/feedback/Loader';
import { useDescriptionWarning } from './hooks';
import { Label } from '../Label';
import { Container, StyledSelect, Description, SelectContainer, IconContainer } from './styled';
const EMPTY_VALUE = '';
export const Select = forwardRef((props, forwardedRef) => {
    const autoId = useGeneratedId('select');
    const { variant = 'outline', id = autoId, label, 'aria-describedby': ariaDescribedBy, description, stretch = false, invalid = false, disabled = false, appearance, value = EMPTY_VALUE, onChange, children, placeholder, size = 'md', loading, labelSize = 'small' } = props, restProps = __rest(props, ["variant", "id", "label", 'aria-describedby', "description", "stretch", "invalid", "disabled", "appearance", "value", "onChange", "children", "placeholder", "size", "loading", "labelSize"]);
    const isXs = size === 'xs';
    const iconSize = isXs ? 10 : 16;
    const hasValue = value !== EMPTY_VALUE;
    const hasPlaceholder = Boolean(placeholder);
    const controlledValue = hasPlaceholder && !hasValue ? EMPTY_VALUE : value;
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };
    const describedBy = ariaDescribedBy || (description && `${id}-description`);
    useDescriptionWarning({ ariaDescribedBy, description });
    const selectProps = Object.assign(Object.assign({}, restProps), { ref: forwardedRef, id,
        disabled, 'aria-describedby': describedBy, value: controlledValue, onChange: handleChange });
    const styledSelectProps = {
        $variant: variant,
        $showPlaceholderStyle: hasPlaceholder && !hasValue,
        $size: size,
        $iconSize: iconSize,
    };
    return (<Container $stretch={stretch}>
      {label && (<Label htmlFor={id} $invalid={invalid} $labelSize={labelSize}>
          {label}
        </Label>)}
      <SelectContainer $variant={variant} $invalid={invalid} $appearance={appearance}>
        <IconContainer $variant={variant} $size={size}>
          {loading ? <Loader size={6}/> : <Falcon icon="chevron-down" $size={iconSize}/>}
        </IconContainer>
        <StyledSelect {...selectProps} {...styledSelectProps} aria-busy={loading}>
          {hasPlaceholder && (<option disabled hidden value={EMPTY_VALUE}>
              {placeholder}
            </option>)}
          {children}
        </StyledSelect>
      </SelectContainer>
      {description && (<Description $invalid={invalid} id={describedBy} $disabled={disabled}>
          {description}
        </Description>)}
    </Container>);
});
